import $ from 'jquery';
import { refreshScroll } from '../core/ScrollService.js';
import Utils from '../utils/Utils.js';
import { initMobileFilter } from '../features/mobileFilter.js';

export class EventsPage {
    static matches() {
        return document.body.classList.contains('page-template-tpl-events');
    }

    init() {
        let url = new URL(window.location);
    if (document.body.classList.contains('page-template-tpl-events')) {
        let eventsPaged = url.searchParams.has('pg') ? url.searchParams.get('pg') : 1;

        const resetEventsVars = () => {
            eventsPaged = 1;
        };

        let doEventsAjax = function (append = false) {
            url = new URL(window.location);

            if (append) {
                $('.eventsList').find('.loadMoreButton').addClass('loadMoreButton--loading');
            } else {
                $('.eventsList').find('.ajaxList').addClass('ajaxList--loading');
            }

            $.ajax({
                url: ajaxVars.url,
                type: 'get',
                data: {
                    action: 'events_ajax',
                    paged: eventsPaged,
                    offset: 1,
                    category: url.searchParams.get('category')
                },
                success: function (result) {
                    if (append) {
                        $('.eventsList').find('.loadMoreButton').remove();
                        $('.eventsList').find('.ajaxList').find('.ajaxList_results').append($(result).html());
                    } else {
                        $('.eventsList').find('.ajaxList').removeClass('ajaxList--loading').find('.ajaxList_results').html($(result).html());
                    }
                    initEventsLoadMore();
                    refreshScroll(document.querySelector('.eventsList .ajaxList_results'));
                },
                error: function (result) { },
            });
        };

        $('.eventsCategorie').find('a').on('click', function (e) {
            e.preventDefault();

            eventsPaged = 1;
            url.searchParams.delete('pg');

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') != 'all') {
                    $(this).removeClass('active');
                }
            } else {
                $('.eventsCategorie .active').removeClass('active');
                $(this).addClass('active');
            }

            if ($(this).hasClass('active')) {
                if ($(this).attr('data-value') == 'all') {
                    url.searchParams.delete('category');
                } else {
                    url.searchParams.set('category', $(this).attr('data-value'));
                }
            } else {
                url.searchParams.delete('category');
            }

            Utils.updateUrl(url.href);
            doEventsAjax();
        });

        initMobileFilter(doEventsAjax, resetEventsVars);

        let initEventsLoadMore = () => {
            $('.eventsList').find('.ajaxList').find('.loadMoreButton').on('click', function () {
                $(this).attr('disabled', 'disabled');
                eventsPaged++;
                url.searchParams.set('pg', eventsPaged);
                Utils.updateUrl(url.href);
                doEventsAjax(true);
            });
        };

    }
    }
}